import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Image, ItemCard } from 'reaxl';
import InventoryImagePlaceholder from '../InventoryImagePlaceholder/index.js';

/**
 *  Renders a grid of image-focused ItemCards.
 *
 */

function ImageSelector(_ref) {
  let {
    data,
    className,
    onClick = () => {},
    imageTitlePlaceholderClassName,
    showLabel = true,
    fixedImageWidth,
    fixedImageHeight,
    displayInline = false,
    ...rest
  } = _ref;
  const renderImageTiles = data.map((item, index) => {
    const {
      src,
      label,
      /* eslint-disable no-unused-vars */
      linkType,
      ...itemRest
    } = item;
    delete itemRest.code;
    delete itemRest.urlLabel;
    const hasFixedDimensions = fixedImageWidth && fixedImageHeight;
    const imageTilesClassName = clsx({
      'img-responsive': !hasFixedDimensions
    }, 'margin-horizontal-auto');
    const itemCardCustomHeight = {};
    if (hasFixedDimensions) {
      const textHeight = 20;
      const customCardHeight = label ? fixedImageHeight + textHeight : fixedImageHeight;
      itemCardCustomHeight.minHeight = `${customCardHeight}px`;
      itemCardCustomHeight.justifyContent = 'center';
    }
    const defaultStyle = {
      width: fixedImageWidth,
      height: fixedImageHeight,
      '--aspect-ratio-calculation': `${100 / (fixedImageWidth / fixedImageHeight)}%`,
      'object-fit': 'contain'
    };
    const inlineImagesStyle = displayInline ? {
      border: '1px solid #E1E4E8',
      borderRadius: '4px',
      backgroundColor: '#fff'
    } : {};
    const tileImage = () => !hasFixedDimensions ? /*#__PURE__*/React.createElement(Image, Object.assign({
      className: imageTilesClassName,
      src: src,
      alt: !showLabel || !itemRest.href ? label : ''
    }, itemRest)) : /*#__PURE__*/_jsx("div", {
      className: imageTitlePlaceholderClassName
    }, void 0, /*#__PURE__*/React.createElement(Image, Object.assign({
      className: "margin-horizontal-auto image-label",
      src: src,
      alt: !showLabel || !itemRest.href ? label : ''
    }, itemRest, {
      style: {
        ...defaultStyle,
        ...inlineImagesStyle
      }
    })));
    let ComponentClass = 'div';
    if (itemRest.href) {
      ComponentClass = 'a';
    }
    const sideBar = src ? tileImage() : /*#__PURE__*/React.createElement(InventoryImagePlaceholder, Object.assign({
      imgClassNames: "padding-2",
      noBackground: true,
      style: {
        width: '100%',
        height: '120px'
      }
    }, itemRest));
    return /*#__PURE__*/_jsx("div", {
      className: clsx({
        'col-xs-4 col-sm-2 text-center': displayInline,
        'col-xs-6 col-sm-3 margin-bottom-4 text-center': !displayInline
      })
    }, `image-selector-${index}-${label}`, /*#__PURE__*/React.createElement(ComponentClass, Object.assign({
      className: "link-unstyled"
    }, itemRest), /*#__PURE__*/_jsx(ItemCard, {
      style: itemCardCustomHeight,
      body: showLabel && label,
      sideBar: sideBar,
      uiContext: "portrait",
      onClick: event => onClick(event, item)
    })));
  });
  const renderRows = () => {
    const rootClassName = clsx({
      row: true,
      [className]: true
    });
    return renderImageTiles && /*#__PURE__*/React.createElement("div", Object.assign({
      className: rootClassName
    }, rest), renderImageTiles);
  };
  return renderRows();
}
export default ImageSelector;